<template>
	<div class="group-member-card">
		<head-image :id="member.userId" :name="member.showNickName" :url="member.headImage" :size="42"
			:online="member.online" :isShowUserInfo="canViewProfile"></head-image>
		<div class="name" :title="member.showNickName">{{ member.showNickName }}</div>
		<div v-if="memberRoleLabel" class="role-badge" :class="{ 'role-badge--owner': isOwner }">
			{{ memberRoleLabel }}
		</div>
	</div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";

export default {
	name: "groupMemberCard",
	components: { HeadImage },
	data() {
		return {};
	},
	props: {
		group: {
			type: Object,
			default: () => ({})
		},
		member: {
			type: Object,
			required: true
		},
		canViewProfile: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		isOwner() {
			return this.group && this.member && this.member.userId == this.group.ownerId;
		},
		memberRoleLabel() {
			if (this.isOwner) {
				return '群主';
			}
			if (this.member && this.member.isManager) {
				return '管理员';
			}
			return '';
		}
	}
}
</script>

<style lang="scss" scoped>
.group-member-card {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	gap: 6px;
	padding-top: 2px;
	transition: opacity 0.2s ease;

	&:hover {
		opacity: 0.92;
	}


	.name {
		font-size: 12px;
		text-align: center;
		width: 100%;
		min-width: 0;
		line-height: 1.3;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	.role-badge {
		max-width: 100%;
		padding: 1px 6px;
		border-radius: 999px;
		font-size: 10px;
		line-height: 16px;
		color: var(--im-color-primary);
		background: rgba(var(--im-primary-rgb), 0.08);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.role-badge--owner {
		color: var(--im-color-danger);
		background: rgba(245, 108, 108, 0.08);
	}
}
</style>
